// extracted by mini-css-extract-plugin
module.exports = {"container":"list-data_container__NS3vC","listItem":"list-data_listItem__3potb","label":"list-data_label__312W6","key":"list-data_key__14ygM","icon":"list-data_icon__3yafC"};